export default (object, isMultipleFile = []) =>
  Object.keys(object).reduce((formData, key) => {
    if (isMultipleFile.includes(key) && !!object[key]) {
      Array.from(object[key]).forEach((file) => formData.append(key, file));
    } else {
      formData.append(key, object[key]);
    }
    return formData;
  }, new FormData());
